import React from 'react';
import { Grid, Divider } from '@mui/material';
import VerticalDividerCard from 'components/VerticalDividerCard';
import * as Styled from './style';
import KpiDefinitionDrawer from 'components/KpiDefinitionDrawer/KpiDefinitionDrawer';
import useCustomMediaQuery from 'utils/useCustomMediaQuery';
import { constants, screenSizes } from '../../constants/Constants';
import { helperFunctions } from 'utils/helperFunctions';
import Loader from 'components/Loader/Loader';

interface TimeMetricsCardProps {
  metricsData: Array<{ title: string; value: any }>;
  userBehaviorAndEngagementLoading: boolean;
  KpiDefinitionList?: any;
  showKpiDefinition?: boolean;
  mode: string;
  isDTVValueCreation?: boolean;
}

const TimeMetricsCard: React.FC<TimeMetricsCardProps> = ({
  metricsData,
  userBehaviorAndEngagementLoading,
  KpiDefinitionList,
  showKpiDefinition = false, // Optional with default value
  mode,
  isDTVValueCreation = false,
}) => {
  const { formatTimeWithSeconds } = helperFunctions();
  const isDesktop = useCustomMediaQuery(screenSizes.desktop);
  const screenSizesFlags = {
    mobile: useCustomMediaQuery(screenSizes.mobile),
    ipadMini: useCustomMediaQuery(screenSizes.ipadMini),
    ipadAir: useCustomMediaQuery(screenSizes.ipadAir),
    ipadPro: useCustomMediaQuery(screenSizes.ipadPro),
  };

  const shouldDisplayDivider = (index: number) =>
    !(
      screenSizesFlags.ipadMini ||
      screenSizesFlags.ipadPro ||
      screenSizesFlags.ipadAir
    ) || (index + 1) % 3 !== 0;

  return (
    <Styled.MainContainer xs={12} mode={mode}>
      {userBehaviorAndEngagementLoading ? (
        <Grid item xs={12}>
          <div style={{ margin: '4%' }}>
            <Loader />
          </div>
        </Grid>
      ) : (
        <Styled.InnerContainer
          container
          mode={mode}
          isDesktop={isDesktop}
          isDTVValueCreation={isDTVValueCreation}
          ipadMini={screenSizesFlags.ipadMini}
        >
          {metricsData?.map((metric, index) => (
            <React.Fragment key={index}>
              <Grid
                lg={1.6}
                md={3.5}
                sm={4}
                xs={4}
                item
                data-testid={`appInstalls-header-${metric.title}`}
                className="header-items"
              >
                <VerticalDividerCard
                  numbers={
                    metric.title === constants.overview.avgTimeInThePlatform
                      ? formatTimeWithSeconds(metric.value)
                      : metric.value
                  }
                  description={metric.title}
                  abbreviation={null}
                  isFullStory
                  isMCT
                />
              </Grid>
              {index < metricsData.length - 1 &&
                shouldDisplayDivider(index) && (
                  <Divider
                    orientation="vertical"
                    flexItem
                    className="verticalBarContainer"
                    sx={{
                      marginTop:
                        index === 3 && screenSizesFlags.ipadPro ? '12px' : ' ',
                      ...(index === 2 && {
                        marginTop: screenSizesFlags.mobile
                          ? '20px !important'
                          : '',
                        marginBottom: screenSizesFlags.mobile ? '5px' : '',
                      }),
                    }}
                  />
                )}
            </React.Fragment>
          ))}
        </Styled.InnerContainer>
      )}
      {showKpiDefinition && (
        <div className="desktopDrawerIcon">
          <KpiDefinitionDrawer title="" KpiDefinitionList={KpiDefinitionList} />
        </div>
      )}
    </Styled.MainContainer>
  );
};

export default TimeMetricsCard;
